import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import GreenButton from "../ui/GreenButton.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIDontHaveSolicitor',
  props: {
    estateTitle: String,
    haveOwnSolicitor: Boolean,
  },
  emits: [
    "close",
    "update:haveOwnSolicitor",
    "update:dontHaveOwnSolicitor",
  ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const activeDefault = ref(true);
  const props = __props;
  const close = () => {
    emits("close");
  };

  const features = [
    "Fixed-price conveyancing.",
    "No hidden costs.",
    "Free contract review.",
    "Fast & efficient service.",
  ];

  const updateHaveOwnSolicitor = () => {
    activeDefault.value = false;
    emits("update:haveOwnSolicitor");
  };

  const updateDontHaveOwnSolicitor = () => {
    activeDefault.value = false;
    emits("update:dontHaveOwnSolicitor");
  };

const __returned__ = { emits, activeDefault, props, close, features, updateHaveOwnSolicitor, updateDontHaveOwnSolicitor, ref, GreenButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})